import classnames from 'classnames'
import Loader from './loader'

/**
 * Overlay loader
 */

interface OverlayLoaderProps {
    className?: string
}

/**
 * Render overlay loader
 *
 * @param {OverlayLoaderProps} props
 * @return {JSX.Element}
 */
const OverlayLoader = (props: OverlayLoaderProps) => (
    <div className={classnames({
        'loader': true,
        [props.className ?? '']: !!props.className,
    })}>
        <div className="loader__inner">
            <div className="loader__content">
                <Loader />
            </div>
        </div>
    </div>
)

export default OverlayLoader
